import { Tabs, TabsProps } from "antd";
import SupplierCodes from "./SupplierCodes";

const onChange = (key: string) => {
  console.log(key);
};

const items: TabsProps["items"] = [
  {
    key: "1",
    label: "البيانات الاساسيه ",
    children: <SupplierCodes />,
  },
  {
    key: "2",
    label: "جهات الاتصال",
    children: <>2</>,
  },
];
function TabsSupplierCodes() {
  return (
    <div>
      <Tabs onChange={onChange} type="card" items={items} />;
    </div>
  );
}

export default TabsSupplierCodes;
